export const navContent = {
  products: {
    en: 'Products',
    zh: '产品列表',
  }
};

export const webContent = {
  wineTitle: {
    en: 'Wine',
    zh: '加拿大美酒',
  },
  wineDescription: {
    en: '',
    zh: `色彩斑斓的枫叶，清澈纯净的内陆湖泊，壮观的尼亚拉加大瀑布，世界最长的海岸线，再加上悠久的酿造历史，独特气候赋予的甜美品质，
    坐落于北美洲最北端的加拿大是很多人心目中的旅行圣地，更是许多酒谜的忠实爱好之地。冰酒是大自然赋予葡萄酒爱好者的礼物，加拿大则是制造这份礼物的绝佳之地，
    由于加拿大尼亚加拉半岛的气候特别适合冰酒的生产，因此加拿大冰酒在国际上一直享誉盛名。
    除此之外，加拿大的红酒、蓝莓酒、烈酒也因其独特的气候条件和酿造工艺而别具风味。`,
  },
};